import axios from "axios";
import md5 from "js-md5";

export const url = process.env.VUE_APP_API_URL
const shareBase = `https://ticket.jifen360.com${process.env.VUE_APP_PUBLIC_PATH}/`
export const share = {
    scan: `${shareBase}scan?mark=`,
    lounge: `${shareBase}lounge?mark=`
}

export const $_ajax = axios.create({
    headers: {
        'Content-Type': 'application/json,charset=UTF-8',
    },
    // withCredentials: true
})


class axiosApi {
    #encode
    #body
    #header
    #enctry

    constructor(data) {
        let _url = url
        if (data.score_type && data.score_type === "xm_air") {
            _url = "https://apis.jifen360.com/api"
        }
        this.#encode = {
            site: {
                url: `${_url}/site`,
                token: "468542ba9984fb15b985defaac25b7fb"
            },
            shop: {
                url: `${_url}/shop`,
                token: "8N1t11xCdvgNHsVaKpAPQC7e8JY0Mks6"
            },
            ticket: {
                url: `${_url}/ticket`,
                token: "QZERUKOhg4bdEDBtlyWOOormHiZTOXYT"
            },
            pay: {
                url: `${_url}/pay`,
                token: "3OOoP88ZPQx5dB69Np2NmeNjae0U8Hag"
            },
            coupon: {
                url: `${_url}/third_coupon`,
                token: "lFoznEqOd457SyKH1GDPyTHHUUVtnjxL"
            },
            airport: {
                url: `${_url}/airport`,
                token: "3LKB7pfEsyLltBVUqHITGd62MdbvYTOs"
            }
        }
        this.#enctry = this.#encode[data.encode]
        this.#body = data.body
        this.#header = {
            method: data.method,
            sign: this.getSign(),
            times: this.timer()
        }
    }

    timer() {
        let date = new Date()
        let dateZero = (value) => {
            return parseInt(value) < 10 ? "0" + value : value;
        }

        return `${date.getFullYear()}-${dateZero(date.getMonth() + 1)}-${dateZero(date.getDate())} ${dateZero(date.getHours())}:${dateZero(date.getMinutes())}:${dateZero(date.getSeconds())}`
    }

    getSign() {
        let key = Object.keys(this.#body).sort()
        // console.log(key)
        let text = key.map(i => {
            if (this.#body[i]) {
                return `${i}${this.#body[i]}`
            } else {
                return ""
            }
        })
        text = text.filter(function (s) {
            return s && s.trim();
        })
        text = text.join("");
        return md5(`${text}${this.#enctry.token}`).toUpperCase()
    }

    param() {
        return {
            header: this.#header,
            body: this.#body
        }
    }

    send(success, fail) {
        $_ajax.post(this.#enctry.url, (this.param())).then(succ => {
            if (success) {
                success(succ.data)
            }
        }).catch(err => {
            if (fail) {
                fail(err)
            }
        })
    }
}

export default axiosApi
